module.exports = __webpack_public_path__ + "img/woman.04ab1696.svg";